// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

export function button34_click(event) {
	var email = 'ikincaid01@gmail.com';
	var subject = 'Job Application';
	var emailBody = 'Job application from '+ $w("#input8").value + ' ' + $w("#input7").value + '\n';
	emailBody += 'Email: ' + $w("#input6").value + '\n';
	emailBody += 'Phone: ' + $w("#input5").value + '\n';
	var attach = $w("#input4").value;
	var url = "mailto:"+email+"?subject="+subject+"&body="+emailBody;//+"?attach="+attach;

	$w("#button34").target = '_blank';
	wixLocation.to(url);
}